import { render, staticRenderFns } from "./productDetail.vue?vue&type=template&id=2ef9b67c&scoped=true&"
import script from "./productDetail.vue?vue&type=script&lang=js&"
export * from "./productDetail.vue?vue&type=script&lang=js&"
import style0 from "./productDetail.vue?vue&type=style&index=0&id=2ef9b67c&prod&lang=scss&"
import style1 from "./productDetail.vue?vue&type=style&index=1&id=2ef9b67c&prod&lang=css&"
import style2 from "./productDetail.vue?vue&type=style&index=2&id=2ef9b67c&prod&scoped=true&lang=css&"
import style3 from "./productDetail.vue?vue&type=style&index=3&id=2ef9b67c&prod&v-show=fromAdmin&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef9b67c",
  null
  
)

export default component.exports